import { type Leaderboard } from "@client/content/modules/Leaderboard/types";
import { IconType } from "@client/types";
import { useI18n } from "@common/hooks/i18n";
import classnames from "classnames";
import * as React from "react";
import Item from "./Item/component";

export type MapProps = {
  current?: Leaderboard.Item | null;
  referring?: Leaderboard.Item | null;
  index: number;
  isMobile: boolean;
  items: Leaderboard.Item[];
  reward: Leaderboard.Reward;
  onClickItem?: (item: Leaderboard.Item) => void;
};

export interface ActionProps {
  learnMore: () => void;
}

export default (props: ActionProps & MapProps) => {
  const i18n = useI18n();

  return (
    <>
      <tr className="reward">
        <td colSpan={props.isMobile ? 3 : 5}>
          <span className="content">
            <span className="name">
              <i className={classnames("far fa-medal", `prize n${props.index + 1}`)} />
              {props.reward.name}
            </span>

            {props.reward.description && (
              <a className="learn_more" href="#" onClick={(e) => (e.preventDefault(), props.learnMore())}>
                <i className={IconType.QuestionCircle} /> {i18n.learnMore}
              </a>
            )}
          </span>
        </td>
      </tr>
      {props.items.map((x) => (
        <Item
          key={x.userId}
          item={x}
          isMobile={props.isMobile}
          current={props.current}
          referring={props.referring}
          onClick={props.onClickItem}
        />
      ))}
    </>
  );
};
